import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const SplashPage = lazy(() => import('../pages/splash/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const HomePage = lazy(() => import('../pages/home/page'));
const CategoriesPage = lazy(() => import('../pages/categories/page'));
const ProductPage = lazy(() => import('../pages/product/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const QuoteRequestPage = lazy(() => import('../pages/quote-request/page'));
const QuoteSuccessPage = lazy(() => import('../pages/quote-success/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const OrderSuccessPage = lazy(() => import('../pages/order-success/page'));
const TrackOrderPage = lazy(() => import('../pages/track-order/page'));
const OrdersPage = lazy(() => import('../pages/orders/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const ReviewPage = lazy(() => import('../pages/review/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/splash',
    element: <SplashPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/categories',
    element: <CategoriesPage />,
  },
  {
    path: '/categories/:category',
    element: <CategoriesPage />,
  },
  {
    path: '/product/:id',
    element: <ProductPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/order-success/:orderId',
    element: <OrderSuccessPage />,
  },
  {
    path: '/track-order',
    element: <TrackOrderPage />,
  },
  {
    path: '/orders',
    element: <OrdersPage />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/review/:orderId',
    element: <ReviewPage />,
  },
  {
    path: '/quote-request',
    element: <QuoteRequestPage />,
  },
  {
    path: '/quote-success',
    element: <QuoteSuccessPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
